import * as z from 'zod'

import { getAddressFromFields } from '@flows/configs/shared/stepUtils'
import { BaseSchema_ContentsV1GetsafeDe as baseSchema } from '@flows/insurance/schemas'

const schema = z.preprocess(
  (values) => {
    const valuesCopy = { ...(values as Record<string, any>) }
    if (!valuesCopy.bike_theft_coverage) {
      valuesCopy.bike_theft_insured_sum_amount = undefined
    }

    if (!valuesCopy.previous_insurance_in_last_5y) {
      valuesCopy.cancelled_by_previous_insurer = undefined
      valuesCopy.number_of_claims_in_last_5y = undefined
    }

    if (valuesCopy.bike_theft_insured_sum_amount !== undefined) {
      valuesCopy.bike_theft_insured_sum_amount = Number(valuesCopy.bike_theft_insured_sum_amount)
    }

    const address = getAddressFromFields(valuesCopy)

    return {
      ...valuesCopy,
      ...address,
      house_no: address.house_number,
      flatmates: valuesCopy.flatmates ?? [],
    }
  },
  baseSchema.merge(
    z.object({
      bike_theft_insured_sum_amount: z.number().int().optional(),
    })
  )
)

export default schema
